module.exports = __webpack_public_path__ + "static/img/bannerMiddle.ad39c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerMiddle.png
// module id = Ojjk
// module chunks = 1